import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { SolicitudService } from './solicitud.service';
import { HttpParams } from '@angular/common/http';
import { SolicitudItemResultsViewModel, SolicitudViewModel } from './solicitud.types';
import { Table } from 'primeng/table';

@Component({
    selector: 'app-solicitud-list',
    templateUrl: './solicitud-list.component.html',
})
export class SolicitudListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;
    resultSolicitud: SolicitudItemResultsViewModel;
    cols: any[];
    public isCollapsed = false;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private solicitudService: SolicitudService,
    ) {
        super();
    }

    ngOnInit() {
        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Image', header: '' },
            { field: 'Codigo', header: 'Nº Solicitud' },
            { field: 'IdEstadoSolicitudDescripcion', header: 'Estado' },
            { field: 'NifCif', header: 'NIF' },
            { field: 'Importador', header: 'Importador' },
            { field: 'Direccion', header: 'Dirección' },
            { field: 'NRegistro', header: 'Nº Registro' },
        ];

        this.resultSolicitud = new SolicitudItemResultsViewModel();

        this.form = this.fb.group({
            Codigo: ['', Validators.required],
        });

        this.loadBack();
    }

    loadBack(): void {
        if (this.solicitudService.currentFilterSolicitud?.Codigo != '' && this.solicitudService.currentFilterSolicitud?.Codigo != undefined) {
            this.form.patchValue({
                Codigo: this.solicitudService.currentFilterSolicitud.Codigo,
            });

            this.onSearchButton();
        }
    }

    onSearchButton(): void {
        this.removeValidators('Codigo');
        this.addValidator('Codigo', Validators.required);

        if (this.isFieldInvalidNoSubmit('Codigo', 'required')) {
            return;
        }

        this.removeValidators('Codigo');

        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.search(0);

        this.solicitudService.currentFilterSolicitud.Codigo = this.form.value.Codigo;

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    private search(pageNumber: number, asc = 0, orderBy = ''): void {
        let params = new HttpParams();

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);

        params = params.append('codigo', this.form.value.Codigo);

        this.loading = true;
        this.solicitudService.getSolicitudPagedByFilter(params).subscribe(result => {
            this.resultSolicitud = result;
            this.loading = false;
        });
    }

    onSearchLazy(event: any): void {
        if (!event.rows || event.sortField == 'Link' || event.sortField == 'Image') {
            return;
        }

        let pageNumber = event.first / event.rows;

        this.search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton(): void {
        this.form.setValue({
            Codigo: '',
        });
        this.searchingButton = false;
        this.isCollapsed = false;
    }

    onEdit(item: SolicitudViewModel): void {
        this.router.navigate(['/mantenimiento/general/solicitudes/edit', item.Id]);
    }

    /**
     * Para controlar la propiedad disabled del botón de reset.
     * @returns boolean
     */
    formIsUntouched(): boolean {
        return this.form.pristine || !this.form.dirty;
    }
}
